registerGlobal('EmscriptenNotification');

EmscriptenNotification.addID = function(table_name, id) {
    try {
        var storageValue = localStorage.getItem(table_name) || "[]";
        var storedIDs = JSON.parse(storageValue);
        if (storedIDs.indexOf(id) !== -1) return;
        storedIDs.push(id);
        localStorage.setItem(table_name, JSON.stringify(storedIDs));
    } catch(e) {
    }
}

EmscriptenNotification.logQuery = function(query) {
    if (!FB || !FB.AppEvents) return;
    var params = {};
    params['query'] = query;
    params['facebookId'] = EmscriptenNotification.getID();
    FB.AppEvents.logEvent("fb_custom_notification_received", null, params);
}

EmscriptenNotification.removeID = function(table_name, id) {
    try {
        var storageValue = localStorage.getItem(table_name) || "[]";
        var storedIDs = JSON.parse(storageValue);
        var index = storedIDs.indexOf(id);
        if (index === -1) return;
        storedIDs.splice(index, 1);
        localStorage.setItem(table_name, JSON.stringify(storedIDs));
    } catch(e) {
    }
}

EmscriptenNotification.getID = function() {
    if (!EmscriptenFacebook || !EmscriptenFacebook.statusData) return "";
    return EmscriptenFacebook.statusData.uid || "";
}

EmscriptenNotification.listIDs = function(table_name) {
    try {
        var storageValue = localStorage.getItem(table_name) || "[]";
        var storedIDs = JSON.parse(storageValue);
        var res = new Module.VectorWstring();
        for (var i = 0; i < storedIDs; i++) {
            res.push_back(storedIDs[i]);
        }
        return res;
    } catch(e) {
        return new Module.VectorWstring();
    }
}



//////////////////
// WEBPACK FOOTER
// /src/contrib/clawext/src/claw_ext/network/push_notifications/emscripten/js/Application.notification.js
// module id = 31
// module chunks = 0